import React from "react";
import { Pressable, StyleSheet, Text, ViewStyle } from "react-native";
import { Colors } from "../../../theme/colors";
import { Typography } from "../../../theme/typography";

type Variant = "primary" | "light" | "ghost";

type Props = {
  title: string;
  onPress: () => void;
  variant?: Variant;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  style?: ViewStyle;
  disabled?: boolean;
};

export function AppButton({
  title,
  onPress,
  variant = "primary",
  leftIcon,
  rightIcon,
  style,
  disabled,
}: Props) {
  const isGhost = variant === "ghost";
  const isLight = variant === "light";

  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      style={({ pressed }) => [
        styles.base,
        isGhost && styles.ghost,
        isLight && styles.light,
        !isGhost && !isLight && styles.primary,
        pressed && !disabled ? { opacity: 0.9, transform: [{ scale: 0.99 }] } : null,
        disabled ? { opacity: 0.4 } : null,
        style,
      ]}
    >
      {leftIcon}
      <Text
        style={[
          styles.text,
          isGhost && { color: Colors.white },
          isLight && { color: Colors.darkText },
          !isGhost && !isLight && { color: Colors.white },
        ]}
      >
        {title}
      </Text>
      {rightIcon}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  base: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 12,
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  text: {
    fontSize: 15,
    fontFamily: Typography.sans,
    fontWeight: "600",
  },
  primary: {
    backgroundColor: Colors.orange500,
    shadowColor: "#000",
    shadowOpacity: 0.18,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 6 },
    elevation: 6,
  },
  light: {
    backgroundColor: Colors.white,
  },
  ghost: {
    backgroundColor: Colors.ghostBg,
  },
});
